import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const faqs = [
  {
    question: 'هل أحتاج إلى اتصال بالإنترنت لاستخدام الاستراحة؟',
    answer:
      'لا، هذا هو الجمال الحقيقي لاستراحة شاشتنا. الاستراحة تعمل بالكامل عبر شبكة واي فاي المحلية الخاصة بالمنشأة. كل ما تحتاجه هو الاتصال بشبكة واي فاي للمكان الذي تتواجد فيه (فندق، مستشفى، مقهى) وستتمكن من الاستمتاع بجميع المحتويات بدون أي اتصال بالإنترنت الخارجي.',
  },
  {
    question: 'ما هي الأجهزة التي تدعمها الاستراحة؟',
    answer:
      'تدعم الاستراحة جميع الأجهزة الحديثة. يمكنك استخدام تطبيق الويب عبر أي متصفح حديث (Chrome, Safari, Firefox, Edge) على أجهزة الكمبيوتر والتابلت. كما يتوفر تطبيق جوال مخصص لنظامي iOS (iPhone وiPad) وAndroid متاح للتحميل من App Store وGoogle Play.',
  },
  {
    question: 'كيف يمكن لمنشأتي الانضمام كمزود شبكة محلية؟',
    answer:
      'الأمر بسيط جداً! تواصل معنا عبر نموذج الاتصال أو عبر البريد الإلكتروني أو الهاتف. سيقوم فريقنا التقني بزيارة منشأتك لتقييم البنية التحتية الحالية، ثم نقوم بتثبيت النظام وتخصيصه حسب احتياجاتك خلال 48 ساعة فقط، مع تقديم تدريب كامل لفريقك.',
  },
  {
    question: 'ما جودة الصورة والصوت المتاحة في الاستراحة؟',
    answer:
      'نقدم محتوى بجودة تصل إلى 4K UHD مع دعم صوت Dolby Digital للمحتوى المتوفر بهذه المواصفات. الجودة تعتمد على قدرة شبكتك المحلية وسرعتها، وعادةً تكفي شبكة واي فاي بسرعة 10 Mbps لمشاهدة محتوى بجودة Full HD بدون أي انقطاع.',
  },
  {
    question: 'هل يمكنني تخصيص المحتوى المعروض في منشأتي؟',
    answer:
      'بالتأكيد! تتيح لوحة التحكم الإدارية تحكماً كاملاً في المحتوى المعروض. يمكنك إضافة أو حذف المحتوى، وتنظيمه في فئات مخصصة، وتحديد أوقات العرض، وحتى إضافة محتوى خاص بمنشأتك مثل إعلانات الخدمات أو الفعاليات.',
  },
  {
    question: 'ما هي خيارات الدعم الفني المتاحة؟',
    answer:
      'نوفر دعماً فنياً متكاملاً على مدار الساعة طوال أيام الأسبوع. يشمل ذلك: الدعم عبر البريد الإلكتروني مع ضمان الرد خلال 4 ساعات، والدعم الهاتفي المباشر خلال ساعات العمل، وخدمة الدردشة الفورية عبر واتساب. كما نوفر قسم الأسئلة الشائعة والأدلة التقنية المفصلة على منصتنا.',
  },
];

const channels = [
  {
    icon: '✉️',
    title: 'البريد الإلكتروني',
    value: 'shashatana.ye@gmail.com',
    desc: 'راسلنا في أي وقت وسنرد عليك خلال 4 ساعات عمل كحد أقصى.',
    color: 'var(--accent-purple)',
  },
  {
    icon: '📞',
    title: 'الهاتف المباشر',
    value: '+967 783 124 226',
    desc: 'تحدث مع أحد متخصصينا مباشرة من الأحد إلى الخميس، 9ص - 6م.',
    color: 'var(--accent-cyan)',
  },
  {
    icon: '💬',
    title: 'واتساب',
    value: '+967 783 124 226',
    desc: 'تواصل معنا عبر واتساب للحصول على دعم سريع في أي وقت.',
    color: 'var(--accent-green)',
  },
];

function FAQItem({ faq, index }) {
  const [open, setOpen] = useState(false);

  return (
    <div className={`faq-item ${open ? 'open' : ''}`}>
      <button
        className="faq-question"
        onClick={() => setOpen(!open)}
        aria-expanded={open}
      >
        <span className="faq-question-text">{faq.question}</span>
        <span className="faq-icon">{open ? '−' : '+'}</span>
      </button>
      <div className={`faq-answer ${open ? 'open' : ''}`}>
        <p className="faq-answer-text">{faq.answer}</p>
      </div>
    </div>
  );
}

function Support() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
    setFormData({ name: '', email: '', subject: '', message: '' });
  };

  return (
    <>
      {/* Page Hero */}
      <section className="page-hero">
        <div className="bg-blobs">
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span className="page-hero-badge">🛟 مركز الدعم</span>
          <h1 className="page-hero-title">
            نحن هنا{' '}
            <span className="gradient-text">لمساعدتك</span>
            <br />
            في كل خطوة
          </h1>
          <p className="page-hero-subtitle">
            فريق الدعم الفني لدينا جاهز للإجابة على جميع استفساراتك
            ومساعدتك في الحصول على أفضل تجربة مع استراحة شاشتنا .
          </p>
        </div>
      </section>

      <div className="divider" />

      {/* Support Channels */}
      <section className="section section-alt">
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            قنوات{' '}
            <span className="gradient-text">التواصل</span>
          </h2>
          <p className="section-subtitle">
            اختر القناة الأنسب لك للتواصل مع فريق الدعم الفني المتخصص لدينا.
          </p>
          <div className="support-channels-grid">
            {channels.map((channel) => (
              <div className="channel-card" key={channel.title}>
                <span className="channel-icon">{channel.icon}</span>
                <h3 className="channel-title">{channel.title}</h3>
                <p
                  className="channel-value"
                  style={{ color: channel.color }}
                  dir="ltr"
                >
                  {channel.value}
                </p>
                <p className="channel-desc">{channel.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Contact Form */}
      <section className="section">
        <div className="bg-blobs" style={{ opacity: 0.4 }}>
          <div className="blob blob-1" style={{ width: '350px', height: '350px' }} />
          <div className="blob blob-2" style={{ width: '280px', height: '280px' }} />
        </div>
        <div className="grid-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            أرسل لنا{' '}
            <span className="gradient-text">رسالة</span>
          </h2>
          <p className="section-subtitle">
            املأ النموذج أدناه وسيتواصل معك أحد أعضاء فريقنا في أقرب وقت ممكن.
          </p>

          <div className="contact-form-wrap">
            {submitted && (
              <div
                style={{
                  background: 'rgba(16, 185, 129, 0.1)',
                  border: '1px solid rgba(16, 185, 129, 0.4)',
                  borderRadius: 'var(--radius-md)',
                  padding: 'var(--spacing-lg)',
                  marginBottom: 'var(--spacing-xl)',
                  color: 'var(--accent-green)',
                  fontWeight: '600',
                  textAlign: 'center',
                  fontSize: '1rem',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 'var(--spacing-sm)',
                }}
              >
                <span>✅</span>
                <span>تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.</span>
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label className="form-label" htmlFor="name">
                    الاسم الكامل <span style={{ color: 'var(--accent-orange)' }}>*</span>
                  </label>
                  <input
                    className="form-input"
                    type="text"
                    id="name"
                    name="name"
                    placeholder="أدخل اسمك الكامل"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group">
                  <label className="form-label" htmlFor="email">
                    البريد الإلكتروني <span style={{ color: 'var(--accent-orange)' }}>*</span>
                  </label>
                  <input
                    className="form-input"
                    type="email"
                    id="email"
                    name="email"
                    placeholder="example@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    dir="ltr"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="subject">
                  موضوع الرسالة <span style={{ color: 'var(--accent-orange)' }}>*</span>
                </label>
                <input
                  className="form-input"
                  type="text"
                  id="subject"
                  name="subject"
                  placeholder="اكتب موضوع رسالتك"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="message">
                  الرسالة <span style={{ color: 'var(--accent-orange)' }}>*</span>
                </label>
                <textarea
                  className="form-input form-textarea"
                  id="message"
                  name="message"
                  placeholder="اكتب رسالتك هنا بالتفصيل..."
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn-primary form-submit">
                <span>📨</span>
                <span>إرسال الرسالة</span>
              </button>
            </form>
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* FAQ Section */}
      <section className="section section-alt">
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="glow-line" />
          <h2 className="section-title">
            الأسئلة{' '}
            <span className="gradient-text">الشائعة</span>
          </h2>
          <p className="section-subtitle">
            إجابات شاملة لأكثر الأسئلة التي يطرحها مستخدمونا وشركاؤنا.
          </p>
          <div className="faq-container">
            {faqs.map((faq, index) => (
              <FAQItem key={index} faq={faq} index={index} />
            ))}
          </div>
        </div>
      </section>

      <div className="divider" />

      {/* Bottom CTA */}
      <section className="cta-banner section">
        <div className="bg-blobs" style={{ opacity: 0.3 }}>
          <div className="blob blob-1" />
          <div className="blob blob-2" />
        </div>
        <div className="dot-pattern" />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div className="cta-banner-inner">
            <div style={{ fontSize: '3rem', marginBottom: 'var(--spacing-lg)' }}>
              🎯
            </div>
            <h2 className="cta-banner-title">
              لم تجد إجابة{' '}
              <span className="gradient-text">لسؤالك؟</span>
            </h2>
            <p className="cta-banner-subtitle">
              فريقنا المتخصص جاهز للإجابة على جميع استفساراتك والمساعدة في
              حل أي مشكلة تواجهها.
            </p>
            <div className="cta-buttons">
              <a
                href="mailto:shashatana.ye@gmail.com"
                className="btn-primary"
              >
                <span>✉️</span>
                <span>راسلنا مباشرة</span>
              </a>
              <Link to="/terms" className="btn-outline">
                <span>📋</span>
                <span>الشروط والسياسة</span>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Support;